import { z } from 'zod';

export const QuarkFormationLevels = z.object({
  id: z.string().uuid(),
  name: z.string(),
  code: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type QuarkFormationLevelsT = z.infer<typeof QuarkFormationLevels>;

export const QuarkFormationLevelsInsert = QuarkFormationLevels.partial();

export type QuarkFormationLevelsInsertT = z.infer<
  typeof QuarkFormationLevelsInsert
>;

export const QuarkFormationLevelsUpdate = QuarkFormationLevels.partial();

export type QuarkFormationLevelsUpdateT = z.infer<
  typeof QuarkFormationLevelsUpdate
>;
